import { EmployeeRole } from '@makemydeal/dr-platform-types/';

export enum Persona {
    Dealer = 'Dealer',
    Shopper = 'Shopper',
    Dealmaker = 'Dealmaker',
    System = 'System'
}

export { EmployeeRole };

export enum RelationShip {
    Spouse = 'Spouse',
    Relative = 'Relative',
    Other = 'Other'
}

export enum DealStatus {
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    Pending = 'Pending',
    Draft = 'Draft'
}

export enum DealType {
    Cash = 'Cash',
    Lease = 'Lease',
    Finance = 'Finance'
}

export enum IncentiveType {
    MilitaryVeteran = 'Military/Veteran',
    FirstResponder = 'First Responder',
    StudentRecentGraduate = 'Student/Recent Grad',
    Loyalty = 'Loyalty',
    Conquest = 'Conquest',
    PrivateOffer = 'Private Offer'
}
